export default "__VITE_ASSET__C$rLqWFv__"